module.exports = __webpack_public_path__ + "static/media/161007-DSC05096-28_Small.7951cce0.jpg";